import { InfluencerTransaction } from '@hub/shared'
import { useTranslation } from 'react-i18next'

import './transfer-receipt.component.scoped.scss'

interface Props {
  transactionObject?: InfluencerTransaction | null
}

export default ({ transactionObject }: Props) => {
  const [t] = useTranslation('transferReceipt')

  return transactionObject &&
    transactionObject?.transaction?.paymentGatewayReceiptBankUrl &&
    transactionObject?.transaction?.paymentType === 'nf' &&
    ['paid', 'paidByFinance', 'processing', 'withdrawing'].includes(transactionObject?.transaction?.transactionStatus) ? (
    <a href={transactionObject?.transaction?.paymentGatewayReceiptBankUrl} target="_blank" className="button button-primary small">
      {t('transferReceipt')}
    </a>
  ) : null
}
